import { useContext } from 'preact/hooks';
import { ChatContext } from '../hooks/context.js';

export function TypingIndicator({ visible, isFloatpanel }) {
  const { cfg } = useContext(ChatContext);
  if (!visible) return null;

  return (
    <div class={`mc-typing${isFloatpanel ? ' mc-gtyping' : ''}`} aria-hidden="true">
      <div class="mc-av-sm">
        {cfg.botAvatar
          ? <img src={cfg.botAvatar} alt={cfg.botName} loading="lazy" />
          : cfg.botInitials
        }
      </div>
      <div class="mc-dots">
        <div class="mc-dot" />
        <div class="mc-dot" />
        <div class="mc-dot" />
      </div>
    </div>
  );
}
